export default "__VITE_ASSET__DgVyxDco__"